export const ALL = 'all'

export const PaymentStatusFilter = Object.freeze({
  DEBITABLE: 'debitable',
  UNSIGNED: 'unsigned',
})

export const DEFAULT_SEARCH_FILTERS = { status: ALL, storeId: ALL }

export const ONGOING_PAYMENT_PATH = '/payments/ongoing'
